import { render, staticRenderFns } from "./ModalStudyComplete.vue?vue&type=template&id=ebb4ad16&scoped=true&lang=pug"
import script from "./ModalStudyComplete.vue?vue&type=script&lang=ts"
export * from "./ModalStudyComplete.vue?vue&type=script&lang=ts"
import style0 from "./ModalStudyComplete.vue?vue&type=style&index=0&id=ebb4ad16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb4ad16",
  null
  
)

export default component.exports